import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { initializeApp } from "firebase/app";
import App from './App.jsx';
import { store } from './store/store';
import { firebaseConfig } from './firebase/firebaseConfig';
import './i18n';
// import * as serviceWorker from './utils/serviceWorker';
import { ConfigProvider } from 'antd';
import ar from 'antd/locale/ar_EG';
import en from 'antd/locale/en_US';

initializeApp(firebaseConfig);
const rootElement = document.getElementById('root');

function getLocale() {
  const savedLanguage = localStorage.getItem('lang_selection') || "en";

  if (savedLanguage === "en") {
    return en;
  } else if (savedLanguage === "ar") {
    return ar;
  }
  return en;
}

createRoot(rootElement).render(
  <Provider store={store}>
    <ConfigProvider locale={getLocale()}>
      <App />
    </ConfigProvider>
  </Provider>,
);
// serviceWorker.register();
